import { render } from "./MultiSelectedFlight.vue?vue&type=template&id=22abb346&scoped=true"
import script from "./MultiSelectedFlight.vue?vue&type=script&lang=js"
export * from "./MultiSelectedFlight.vue?vue&type=script&lang=js"

import "./MultiSelectedFlight.vue?vue&type=style&index=0&id=22abb346&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22abb346"]])

export default __exports__